export default "__VITE_ASSET__Dg5aCOLN__"